export const RECOMMENDED_BUSINESS_BANKS = [
  'Bluevine',
  'Bank of America',
  'Wells Fargo',
  'Chase',
  'U.S. Bank',
  'Relay Financial',
  'PNC',
]

export const HEARD_BANKING_LEARN_MORE_URL =
  'https://www.joinheard.com/heard-banking'

export const UNIT_LOCAL_STORAGE_KEYS = [
  'unitCustomerToken',
  'unitVerifiedCustomerToken',
] as const

export const clearUnitLocalStorage = (): void => {
  UNIT_LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))
}

export const UNIT_SESSION_TTL_MS = 23 * 60 * 60 * 1000

// Plaid institution_id for Heard Banking (provider: Unit). A FinancialAccount
// at this institution represents a connected Heard banking account.
export const HEARD_BANKING_PLAID_INSTITUTION_ID = 'ins_138356'

export const HEARD_BANKING_PROMO_COPY = {
  titlePrefix: 'Introducing Heard Banking',
  titleSuffix: ', get $150 on us',
  cta: 'Open my account',
  body: (date: string, time: string) =>
    `Free business checking, savings, and a debit card, built into Heard. Apply by ${date} ${time} PT and we'll deposit $150 after your first 5 debit card purchases.`,
  bodyNoDeadline:
    "Free business checking, savings, and a debit card, built into Heard. Apply now and we'll deposit $150 after your first 5 debit card purchases.",
} as const

export const HEARD_BANKING_STANDARD_DISCLAIMER =
  'Heard is a financial technology company and is not a bank. Banking services are provided by i3 Bank, Member FDIC.'

export const CONNECT_BANK_PATHS = {
  onboarding: '/onboarding-v2?stage=connect&step=link',
  dashboard: '/accounts/connect',
} as const
